import { useParams, Navigate, Link } from 'react-router-dom';
import { SEO } from '../../../components/seo/SEO';
import { categories } from '../../../data/categories';
import { useState, useEffect } from 'react';
import { supabase, Post } from '../../../lib/supabase';
import { getBaseUrl } from '../../../lib/utils';

function formatDate(dateStr: string) {
  const d = new Date(dateStr);
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
}

const mockByCategory: Record<string, Post[]> = {
  'ai-creation': [
    { id: 'a1', slug: 'cursor-ai-workflow-full', title: 'CursorとClaudeで仕様書を書いてから実装する流れを整理した', excerpt: '「とりあえず作る」から「仕様を固めてから作る」に変えたら、手戻りが激減した。その具体的なフローを記録する。', category_slug: 'ai-creation', published_at: '2026-03-28', tags: ['Cursor', 'Claude'], featured: true, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'a2', slug: 'vibe-coding-what-is', title: 'バイブコーディングとは何か——AIと一緒に作る感覚を言語化してみた', excerpt: 'コードを書くというより、AIと会話しながら形にしていく感覚。その実態と、うまくいくときの条件を整理した。', category_slug: 'ai-creation', published_at: '2026-03-20', tags: ['バイブコーディング'], featured: true, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'a3', slug: 'ui-reproduction-spotify-log', title: 'Spotify風UIをゼロから再現する——詰まったところと解決策の全記録', excerpt: 'デザインを見て「これ作れそう」と思ったが、実際には何度も詰まった。その過程をそのまま残す。', category_slug: 'ai-creation', published_at: '2026-03-12', tags: ['UI再現', 'Spotify'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'a4', slug: 'notion-like-ui-with-ai', title: 'NotionライクなUIをAIだけで作る——ブロックエディタの設計と実装ログ', excerpt: 'ブロックエディタの仕組みを理解しながら、AIと一緒に実装した記録。設計の考え方も残す。', category_slug: 'ai-creation', published_at: '2026-02-20', tags: ['Notion', 'UI再現'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'a5', slug: 'cursor-composer-tips-2026', title: 'Cursor Composerで長い実装を分割する方法——コンテキスト切れを防ぐ3つの工夫', excerpt: '長い実装をAIに任せると途中でコンテキストが切れる。その対策として試した分割戦略を整理した。', category_slug: 'ai-creation', published_at: '2026-04-01', tags: ['Cursor'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
  ],
  'build-log': [
    { id: 'b1', slug: 'readdy-site-week1-log', title: 'Readdy.aiでブログを作った最初の7日間——判断・迷い・失敗の全記録', excerpt: 'ゼロからサイトを立ち上げた1週間。何を決めて、何で詰まって、どう解決したかを全部書く。', category_slug: 'build-log', published_at: '2026-03-05', tags: ['Readdy', 'サイト制作'], featured: true, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'b2', slug: 'spec-driven-development-intro', title: '仕様書ファーストで開発する——AIに「何を作るか」を先に伝える設計', excerpt: 'コードを書く前に仕様書を作ると、AIとのやり取りが劇的に変わる。その具体的な手順と効果。', category_slug: 'build-log', published_at: '2026-03-25', tags: ['仕様書', '制作フロー'], featured: true, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'b3', slug: 'ai-article-writing-flow', title: 'AI記事制作フローを仕様化する——プロンプト設計から構成・校正まで', excerpt: '記事を書くプロセス自体をAIで効率化・仕様化する試み。一気通貫で整理した。', category_slug: 'build-log', published_at: '2026-02-28', tags: ['記事制作', 'プロンプト'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
  ],
  'productivity': [
    { id: 'p1', slug: 'claude-vs-chatgpt-coding', title: 'ClaudeとChatGPTをコーディングで使い比べた——得意・不得意の違いが見えてきた', excerpt: '同じタスクを両方に投げて比較した。どちらが何に向いているか、実感ベースでまとめる。', category_slug: 'productivity', published_at: '2026-03-18', tags: ['Claude', 'ChatGPT', '比較'], featured: true, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 'p2', slug: 'prompt-template-for-ui', title: 'UIコンポーネントを作るときのプロンプトテンプレートを公開する', excerpt: '何度も使い回せるプロンプトの型を作った。Reactコンポーネント生成に特化したバージョン。', category_slug: 'productivity', published_at: '2026-03-10', tags: ['プロンプト', 'React'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
  ],
  'tools-in-use': [
    { id: 't1', slug: 'cursor-deep-dive', title: 'Cursorを3ヶ月使い倒した——できること・できないこと・使い方の変化', excerpt: '最初の印象と3ヶ月後の使い方は全然違った。実際に変わったワークフローと、今も残る課題を整理する。', category_slug: 'tools-in-use', published_at: '2026-03-15', tags: ['Cursor'], featured: true, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
    { id: 't2', slug: 'claude-api-practical', title: 'Claude APIを実務で使う——コスト・速度・精度の実測レポート', excerpt: 'APIとして使ったときの実際のコストと速度を計測した。ChatGPT APIとの比較も含めて整理する。', category_slug: 'tools-in-use', published_at: '2026-02-25', tags: ['Claude', 'API'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null },
  ],
};

const categoryDescriptions: Record<string, { tagline: string; topics: string[] }> = {
  'ai-creation': {
    tagline: 'AIで何かを作る過程を、そのまま残す。',
    topics: ['Cursor / Claude活用', 'UI再現実験', 'バイブコーディング', '仕様書化', 'React実装ログ'],
  },
  'build-log': {
    tagline: '判断・迷い・失敗も含めた、正直な制作記録。',
    topics: ['サイト制作記録', '仕様書ファースト開発', 'AI記事制作フロー', 'プロジェクト全工程ログ'],
  },
  'productivity': {
    tagline: '作業を速く・正確にするための実践整理。',
    topics: ['プロンプト設計', 'ツール比較検証', 'ワークフロー設計', 'テンプレート公開'],
  },
  'tools-in-use': {
    tagline: '使った結果だけを書く。紹介で終わらない。',
    topics: ['Cursor', 'Claude API', 'ChatGPT', 'Supabase', 'Readdy.ai'],
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      if (!slug) return;
      try {
        const { data, error } = await supabase
          .from('posts')
          .select('*')
          .eq('category_slug', slug)
          .lte('published_at', new Date().toISOString())
          .order('published_at', { ascending: false });
        if (error) throw error;
        setPosts(data && data.length > 0 ? data : (mockByCategory[slug] || []));
      } catch {
        setPosts(mockByCategory[slug] || []);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [slug]);

  if (!category) return <Navigate to="/404" replace />;

  const baseUrl = getBaseUrl();
  const desc = categoryDescriptions[category.slug];
  const pickupPosts = posts.filter((p) => p.featured).slice(0, 2);
  const allPosts = posts;
  const otherCategories = categories.filter((c) => c.slug !== category.slug);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} — つくってなんぼ`,
    description: category.description,
    url: `${baseUrl}/categories/${slug}`,
  };

  return (
    <>
      <SEO
        title={`${category.name} | つくってなんぼ — AI実践メディア`}
        description={category.description}
        canonical={`/categories/${slug}`}
        jsonLd={jsonLd}
      />

      <div className="min-h-screen bg-[#FDFAF6]">

        {/* ── Page header ── */}
        <div className="pt-24 sm:pt-32 pb-8 border-b border-[#E8E0D5]">
          <div className="max-w-2xl mx-auto px-4 sm:px-6">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-xs text-[#9A8E84] mb-5" aria-label="パンくず">
              <Link to="/" className="hover:text-[#2C2416] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>Home</Link>
              <i className="ri-arrow-right-s-line text-[#C8BFB5]"></i>
              <Link to="/categories" className="hover:text-[#2C2416] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>カテゴリ</Link>
              <i className="ri-arrow-right-s-line text-[#C8BFB5]"></i>
              <span className="text-[#7A6E62]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{category.name}</span>
            </nav>

            <p className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              Category
            </p>
            <h1
              className="text-2xl sm:text-3xl font-bold text-[#2C2416] mb-3 leading-snug"
              style={{ fontFamily: "'Noto Serif JP', 'Georgia', serif", letterSpacing: '-0.01em' }}
            >
              {category.name}
            </h1>
            <p className="text-sm text-[#4A3F35] leading-relaxed mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              {category.description}
            </p>

            {/* Tagline + topics */}
            {desc && (
              <div className="mt-4">
                <p className="text-xs font-semibold text-[#5B7B6F] mb-2 border-l-2 border-[#5B7B6F]/40 pl-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {desc.tagline}
                </p>
                <div className="flex flex-wrap gap-1.5 pl-3">
                  {desc.topics.map((t) => (
                    <span key={t} className="text-[11px] text-[#7A6E62] bg-[#F0EBE3] border border-[#E8E0D5] px-2 py-0.5 rounded" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            )}

            <p className="text-xs text-[#9A8E84] mt-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              {loading ? '読み込み中...' : `${allPosts.length}件の記事`}
            </p>
          </div>
        </div>

        {/* ── Pickup ── */}
        {!loading && pickupPosts.length > 0 && (
          <div className="py-7 bg-[#F5EFE6] border-b border-[#E8E0D5]">
            <div className="max-w-2xl mx-auto px-4 sm:px-6">
              <p className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                まず読むならこれ
              </p>
              <div className="space-y-4">
                {pickupPosts.map((post, index) => (
                  <Link
                    key={post.id}
                    to={`/articles/${post.slug}`}
                    className="flex items-start gap-4 group cursor-pointer"
                  >
                    <span className="text-xl font-bold text-[#D4C9BE] leading-none mt-0.5 flex-shrink-0 w-6 text-right" style={{ fontFamily: "'Georgia', serif" }}>
                      {index + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <h3
                        className="text-sm sm:text-base font-semibold text-[#2C2416] leading-snug group-hover:text-[#5B7B6F] transition-colors"
                        style={{ fontFamily: "'Noto Serif JP', serif" }}
                      >
                        {post.title}
                      </h3>
                      {post.excerpt && (
                        <p className="text-xs text-[#7A6E62] mt-1 line-clamp-1 leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                          {post.excerpt}
                        </p>
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ── Article list ── */}
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
          <p className="text-xs font-semibold tracking-widest uppercase text-[#9A8E84] mb-5" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            すべての記事
          </p>

          {loading ? (
            <div className="py-16 text-center">
              <i className="ri-loader-4-line text-3xl text-[#9A8E84] animate-spin block mb-3"></i>
              <p className="text-sm text-[#9A8E84]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>読み込み中...</p>
            </div>
          ) : allPosts.length > 0 ? (
            <div className="divide-y divide-[#EDE7DF]">
              {allPosts.map((post) => (
                <article key={post.id}>
                  <Link
                    to={`/articles/${post.slug}`}
                    className="flex items-start gap-4 py-5 group cursor-pointer"
                  >
                    {/* Thumbnail or placeholder */}
                    {post.image_url ? (
                      <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-md overflow-hidden bg-[#F0EBE3]">
                        <img src={post.image_url} alt={post.title} className="w-full h-full object-cover object-top" loading="lazy" />
                      </div>
                    ) : (
                      <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-md bg-[#F0EBE3] flex items-center justify-center">
                        <i className="ri-article-line text-xl text-[#C8BFB5]"></i>
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                        <span className="text-xs text-[#9A8E84]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                          {formatDate(post.published_at)}
                        </span>
                        {post.featured && (
                          <>
                            <span className="text-[#D4C9BE] text-xs">·</span>
                            <span className="text-[10px] font-semibold text-[#5B7B6F] bg-[#EEF4F2] px-1.5 py-0.5 rounded" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                              おすすめ
                            </span>
                          </>
                        )}
                      </div>
                      <h2
                        className="text-sm sm:text-base font-semibold text-[#2C2416] leading-snug mb-1.5 group-hover:text-[#5B7B6F] transition-colors"
                        style={{ fontFamily: "'Noto Serif JP', serif" }}
                      >
                        {post.title}
                      </h2>
                      {post.excerpt && (
                        <p className="text-xs text-[#7A6E62] leading-relaxed line-clamp-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                          {post.excerpt}
                        </p>
                      )}
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          ) : (
            <div className="py-14 text-center border border-[#E8E0D5] rounded-lg">
              <p className="text-sm text-[#9A8E84] mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>このカテゴリの記事は近日公開予定です</p>
              <Link to="/articles" className="text-xs text-[#5B7B6F] hover:text-[#2C2416] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                他の記事を見る
              </Link>
            </div>
          )}

          {/* ── Other categories ── */}
          <div className="mt-12 pt-8 border-t border-[#EDE7DF]">
            <p className="text-xs font-semibold tracking-widest uppercase text-[#9A8E84] mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              他のカテゴリ
            </p>
            <div className="flex flex-wrap gap-2">
              {otherCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/categories/${cat.slug}`}
                  className="inline-flex items-center gap-1.5 px-3 py-2 border border-[#E8E0D5] rounded-md text-xs text-[#7A6E62] hover:border-[#5B7B6F] hover:text-[#5B7B6F] transition-colors cursor-pointer whitespace-nowrap bg-[#FDFAF6]"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  <i className={`${cat.icon} text-[#5B7B6F]`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* ── Bottom nav ── */}
          <div className="mt-8 pt-6 border-t border-[#EDE7DF]">
            <div className="flex flex-wrap gap-4">
              <Link to="/articles" className="inline-flex items-center gap-1.5 text-sm text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <i className="ri-arrow-left-line text-[#5B7B6F]"></i>
                記事一覧へ
              </Link>
              <span className="text-[#D4C9BE]">·</span>
              <Link to="/about" className="inline-flex items-center gap-1.5 text-sm text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                About
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
